import { Component, OnInit } from '@angular/core';
import { versionLog } from '../../../../helper/update-constant.helper';
import { Router } from "@angular/router";

@Component({
  selector: 'fi-update-banner',
  templateUrl: './update-banner.component.html',
  styleUrls: ['./update-banner.component.scss'],
  standalone: false,
})
export class UpdateBannerComponent implements OnInit {
  showChangeLogBanner = false;

  constructor(
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.showChangeLogBanner = this.getChangeLogToShow();
  }

  hideInDetail(): boolean {
    const url = (this.router.url ?? '').split('?')[0];
    return !url || url === '/';
  }

  getChangeLogToShow(): boolean {
    const diffDays = this.calculateDiff(versionLog.versionChangeDate);
    const notSkipped = localStorage.getItem('changelogSkipped') !== versionLog.currentVersion;
    //localStorage.setItem('changelogSkipped', versionLog.currentVersion);

    if ( diffDays < 0 || diffDays >= versionLog.showDays ) {
      return false;
    }

    return notSkipped;
  }

  calculateDiff( updateDate ): number {
    const currentDate = new Date();
    updateDate = new Date(updateDate);

    const currentDateUtc = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), currentDate.getHours(), currentDate.getMinutes());
    const updateDateUtc = Date.UTC(updateDate.getFullYear(), updateDate.getMonth(), updateDate.getDate(), updateDate.getHours(), updateDate.getMinutes());

    return Math.floor((currentDateUtc - updateDateUtc) / (1000 * 60 * 60 * 24));
  }

  closeChangeLog(): void {
    this.showChangeLogBanner = false;
    localStorage.setItem('changelogSkipped', versionLog.currentVersion);
  }
}
